
import { Colors } from '../../consts/Colors';

export default class Card2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.img = cardData.image
        this.zoneId = cardData.zoneId;
        this.isCorrect = false
        this.zoneDroped = undefined
        this.deck = deck
        this.isGood = false

        this.carteImage = this.scene.add.image(0, 0, this.img).setOrigin(0.5);
        this.add(this.carteImage);
        this.setSize(this.carteImage.width, this.carteImage.height);
        // this.setInteractive({ useHandCursor: true });
        // this.scene.input.setDraggable(this)

        let badAnswerY= -this.carteImage.height/2+30
        if(this.zoneId === 1 || this.zoneId === 3){
            badAnswerY =  -this.carteImage.height/2+10
        }

        this.badAnswerLogo = this.scene.add.image(-this.carteImage.width/2 + 10, badAnswerY, 'badAnswer2').setOrigin(0.5).setAlpha(0)
        this.add(this.badAnswerLogo)
    }

    drop(pointer, gameObject, dropZone) {
        gameObject.isDone = true
        gameObject.x = dropZone.zoneData.zoneXDeck
        gameObject.y = dropZone.zoneData.zoneYDeck + 2.5

        dropZone.onDrop()
        if (dropZone.cardDropped == undefined && gameObject.zoneDroped == undefined) {
            dropZone.cardDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true

        } else if (dropZone.cardDropped !== undefined && gameObject.zoneDroped == undefined) {
            dropZone.cardDropped.resetPosition()
            dropZone.cardDropped.zoneDroped = undefined
            dropZone.cardDropped.isDone = false
            gameObject.zoneDroped = false
            gameObject.isDone = false
            dropZone.cardDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true

        } else if (gameObject.zoneDroped !== undefined && dropZone.cardDropped == undefined) {
            gameObject.zoneDroped.cardDropped = undefined
            gameObject.zoneDroped.isDone = false
            gameObject.zoneDroped = dropZone
            dropZone.cardDropped = gameObject
            gameObject.isDone = true

        } else if (dropZone.cardDropped !== undefined && gameObject.zoneDroped !== undefined) {
            dropZone.cardDropped.x = gameObject.zoneDroped.zoneData.zoneXDeck
            dropZone.cardDropped.y = gameObject.zoneDroped.zoneData.zoneYDeck
            dropZone.cardDropped.zoneDroped = gameObject.zoneDroped
            dropZone.cardDropped.isDone = true
            gameObject.zoneDroped.cardDropped = dropZone.cardDropped
            dropZone.cardDropped = gameObject
            gameObject.zoneDroped = dropZone
            gameObject.isDone = true
        }
        let nbr = this.deck.cartes.filter(x => x.isDone).length
        if (nbr == this.deck.cartes.length) {
            this.deck.validBtn.setUnlocked()
        }
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
            if (gameObject.zoneDroped !== undefined) {
                gameObject.zoneDroped.cardDropped = undefined
                gameObject.zoneDroped.isDone = false
                gameObject.zoneDroped = undefined
            }
        }
    }


    setLocked() {
        this.isDone = true
        this.disableInteractive()
    }

    onDrag(){}

    resetPosition(duration) {
        let nbr = this.deck.cartes.filter(x => x.isDone).length
        if (nbr == this.deck.cartes.length) {
            this.deck.validBtn.setLocked()
        }
        if (duration == undefined) {
            duration = 300
        }
        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.isDone = false
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
    setGood() {
        if (this.isGood === false) {
            this.isGood = true
            let newImage = this.img + "Good"
            this.carteImage.setTexture(newImage)
            this.zoneDroped.destroy()
        }
    }
    setBad() {
        this.badAnswerLogo.setAlpha(1)
    }

    reset() {
        this.resetPosition()
        this.badAnswerLogo.setAlpha(0)
        this.zoneDroped.reset()
        this.zoneDroped = undefined
        this.isDone = false
        this.setInteractive({ useHandCursor: true })
    }
}